import { PrivateContext } from "@/app/components/PrivateContextLoader";
import { useContext, useEffect, useState } from "react";

export const UserFieldCellValue = ({ id }: { id?: string }) => {
  const { users } = useContext(PrivateContext);
  const [displayValue, setDisplayValue] = useState<string | undefined>(id);
  useEffect(() => {
    const matchedUser = (users || []).find((option) => option.id === id);
    setDisplayValue(
      !!matchedUser ? `${matchedUser.first_name} ${matchedUser.last_name}` : "-"
    );
  }, []);

  return <>{displayValue}</>;
};
